/* Certificate-of-Analysis search. Loaded by sections/coa-search.liquid and sections/main-coa-lot.liquid.
   The coa-search section renders a document index (`coa_document` rows per page: [lot, code, certificate
   product name, issued, file]; older indexes carried a 6th store-title slot, still honoured; the rest are fetched with the Section Rendering API +
   paginate.page_param). The CoA page form has three combobox fields (product, code, lot) whose <datalist>s are
   filled from the index and narrowed by the other fields; filled fields are ANDed. Legacy free-text (?q=, the
   lot page's single box) still matches every word against every field. Results are one row per certificate
   with a Download link, exact hits first, newest first. Forms without an index (the lot page) hand off to the
   CoA page via ?q=. The certificate name is Ability's; the Product field offers and matches the STORE title and
   its alternate-name words too, joined on the base product code from assets/search-index.json
   (form[data-search-index]; review 9.18: "baby rabbit complement doesn't autocomplete"). */
(function () {
  'use strict';

  var MAX_ROWS = 200;
  var FILE_BASE = '/cdn/shop/files/';

  function handleize(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function norm(s) { return String(s || '').toLowerCase(); }
  function tokens(q) { return norm(q).split(/[\s,;:/.]+/).filter(Boolean); }

  var indexCache = null;
  function loadIndex(root, titlesUrl) {
    if (indexCache) return indexCache;
    var first = root.querySelector('[data-coa-index]');
    if (!first) return null;
    var docs = JSON.parse(first.textContent || '[]');
    var pages = parseInt(first.getAttribute('data-pages'), 10) || 1;
    var sectionId = first.getAttribute('data-section-id');
    /* metaobject paginate uses a keyed page param (page_<hash>), not `page` */
    var pageParam = first.getAttribute('data-page-param') || 'page';
    var fetches = [];
    for (var p = 2; p <= pages; p++) {
      fetches.push(fetch(window.location.pathname + '?sections=' + encodeURIComponent(sectionId) + '&' + encodeURIComponent(pageParam) + '=' + p, { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (json) {
          var html = json[sectionId] || '';
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var el = doc.querySelector('[data-coa-index]');
          return el ? JSON.parse(el.textContent || '[]') : [];
        })
        .catch(function () { return []; }));
    }
    /* the store-title join resolves with the index so the first fill / search already knows the titles */
    indexCache = Promise.all([Promise.all(fetches), loadTitles(titlesUrl)]).then(function (res) {
      res[0].forEach(function (part) { docs = docs.concat(part); });
      var seen = {};
      return docs.filter(function (d) {
        var k = d[1] + '|' + d[0] + '|' + d[3];
        if (seen[k]) return false;
        seen[k] = true;
        return true;
      });
    });
    return indexCache;
  }

  /* Store titles + alternate-name words per base product code, from the header search's index
     (assets/search-index.json rows [handle, title, skus, terms, popularity, image]; rows are popularity-sorted
     so the first product claiming a code wins). The certificate's product_name is Ability's ("Rabbit
     Complement, 3-4 Week, Sterile"); shoppers type the store's ("Baby Rabbit Complement") or a synonym. */
  var titleMap = {};
  var titlesPromise = null;
  function baseCode(code) { return norm(code).replace(/^(p?\d{5}[a-z]?)[-.].*$/, '$1'); }
  function indexTitles(rows) {
    (rows || []).forEach(function (row) {
      String(row[2] || '').split(/\s+/).forEach(function (sku) {
        var b = baseCode(sku);
        if (b && !titleMap[b]) titleMap[b] = { title: row[1] || '', terms: norm(row[3] || '') };
      });
    });
    return titleMap;
  }
  function loadTitles(url) {
    if (titlesPromise) return titlesPromise;
    if (!url || typeof window.fetch !== 'function') return (titlesPromise = Promise.resolve(titleMap));
    titlesPromise = window.fetch(url, { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : []; })
      .then(function (rows) { return indexTitles(rows); })
      .catch(function () { return titleMap; });
    return titlesPromise;
  }
  function storeTitle(d) { var t = titleMap[baseCode(d[1])]; return t ? t.title : ''; }
  /* Everything the Product field may match against, lower-cased: certificate name, store title, synonym words. */
  function productHay(d) {
    var t = titleMap[baseCode(d[1])];
    return norm(docName(d)) + ' ' + norm(d[2]) + (t ? ' ' + norm(t.title) + ' ' + t.terms : '');
  }
  /* The typed phrase at a word start of the certificate name / store title, or every typed word
     prefix-matching a word of the hay ("young rabbit" -> Baby Rabbit Complement via its alternate-name
     terms). Word starts only: "ba" must not surface Rabbit Brain Acetone Powder through "(RBAP)". */
  function productMatches(d, typed) {
    if (!typed) return true;
    var hay = productHay(d);
    if ((' ' + hay).indexOf(' ' + typed) > -1) return true;
    var words = hay.split(/[\s,;:/()]+/);
    return tokens(typed).every(function (w) {
      return words.some(function (h) { return h.indexOf(w) === 0; });
    });
  }

  function escapeHtml(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function fmtDate(iso) {
    var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || '');
    if (!m) return '';
    return new Date(+m[1], +m[2] - 1, +m[3]).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
  }

  function render(box, q, matches, strings) {
    var out = box.querySelector('[data-coa-results]');
    if (!out) return;
    if (!matches.length) {
      out.innerHTML = '<p class="coa__none">' + strings.none.replace('{{ query }}', escapeHtml(q)) + '</p>';
      return;
    }
    var shown = matches.slice(0, MAX_ROWS);
    var html = '<p class="coa__count">' + strings.results.replace('{{ count }}', matches.length).replace('{{ query }}', escapeHtml(q)) + '</p>';
    html += '<table class="coa-table coa-table--results"><thead><tr><th scope="col">' + escapeHtml(strings.lot) + '</th><th scope="col">' + escapeHtml(strings.product) + '</th><th scope="col">' + escapeHtml(strings.issued) + '</th><th scope="col"></th></tr></thead><tbody>';
    shown.forEach(function (d) {
      html += '<tr><td><a href="/pages/coa/' + handleize(d[0]) + '">' + escapeHtml(d[0]) + '</a></td>';
      /* the store title the shopper searched by, then the name as printed on the certificate when it differs */
      var name = storeTitle(d) || docName(d), cert = docName(d);
      html += '<td>' + escapeHtml(d[1]) + (name ? ' &middot; ' + escapeHtml(name) : '');
      if (cert && norm(cert) !== norm(name)) html += '<span class="coa-table__cert">' + escapeHtml(cert) + '</span>';
      html += '</td>';
      html += '<td>' + escapeHtml(fmtDate(d[3])) + '</td><td>';
      if (d[4]) html += '<a class="btn btn--pill btn--accent btn--xs" href="' + FILE_BASE + escapeHtml(d[4]) + '" target="_blank" rel="noopener">' + escapeHtml(strings.download) + '</a>';
      html += '</td></tr>';
    });
    html += '</tbody></table>';
    if (matches.length > shown.length) html += '<p class="coa__none">' + strings.more.replace('{{ shown }}', shown.length) + '</p>';
    out.innerHTML = html;
  }

  function rank(d, q, words) {
    var lot = norm(d[0]), code = norm(d[1]);
    if (lot === q || handleize(d[0]) === handleize(q)) return 0;
    if (code === q) return 1;
    if (words.indexOf(lot) > -1 && words.indexOf(code) > -1) return 0;
    if (words.indexOf(lot) > -1 || words.indexOf(code) > -1) return 2;
    return 3;
  }

  /* Field-aware matching. crit = {product, code, lot} (trimmed strings, blanks ignored). Product matches the
     certificate product name (or a store title when the index has one; substring); code matches exactly or as a prefix ("31061" finds 31061,
     31061-1); lot matches exactly, as a prefix, or by handle so the lot-page URL form works too. */
  function docName(d) { return d[5] || d[2] || ''; }
  function matchesCrit(d, crit) {
    if (crit.product && !productMatches(d, crit.product)) return false;
    if (crit.code && norm(d[1]).indexOf(crit.code) !== 0) return false;
    if (crit.lot) {
      var lot = norm(d[0]);
      if (lot.indexOf(crit.lot) !== 0 && handleize(d[0]) !== handleize(crit.lot)) return false;
    }
    return true;
  }
  function rankCrit(d, crit) {
    var r = 3;
    if (crit.lot && norm(d[0]) === crit.lot) r = 0;
    if (crit.code && norm(d[1]) === crit.code) r = Math.min(r, 1);
    if (crit.product && (norm(docName(d)) === crit.product || norm(storeTitle(d)) === crit.product)) r = Math.min(r, 2);
    return r;
  }

  function sortMatches(matches, cmp) {
    matches.sort(function (a, b) {
      var c = cmp(a, b);
      if (c) return c;
      if ((a[3] || '') !== (b[3] || '')) return (a[3] || '') < (b[3] || '') ? 1 : -1;
      if (a[0] !== b[0]) return a[0] < b[0] ? 1 : -1;
      return a[1] < b[1] ? -1 : a[1] > b[1] ? 1 : 0;
    });
    return matches;
  }

  /* Datalist options: distinct values of one field over the docs that satisfy the OTHER filled fields, so
     picking a product narrows the codes and lots on offer (and vice versa). Typed text filters the list by
     substring; capped so a several-thousand-lot store never renders a giant <datalist>. Code options carry the
     product name as the option label. Product options are the STORE title where the code is on the store
     (the certificate name as the label, so both are visible and the browser's own value/label filter still
     hits), else the certificate name; typed text is matched synonym-aware (productMatches).
     ponytail: a synonym that is in neither the value nor the label (an alternate-name word) still finds the
     certificates on Search, but the browser's native datalist filter may hide the suggestion for it. */
  var MAX_OPTIONS = 300;
  function fillOptions(form, docs) {
    var crit = readCrit(form);
    ['product', 'code', 'lot'].forEach(function (f) {
      var input = form.querySelector('[data-coa-field=' + f + ']'), list = input && input.list;
      if (!list) return;
      var others = { product: crit.product, code: crit.code, lot: crit.lot };
      var typed = others[f];
      others[f] = '';
      var seen = {}, opts = [];
      for (var i = 0; i < docs.length; i++) {
        var d = docs[i];
        if (!matchesCrit(d, others)) continue;
        var val, label = '';
        if (f === 'product') {
          val = storeTitle(d) || docName(d);
          if (storeTitle(d) && norm(docName(d)) !== norm(val)) label = docName(d);
          if (typed && !productMatches(d, typed)) continue;
        } else {
          val = f === 'code' ? d[1] : d[0];
          if (typed && norm(val).indexOf(typed) < 0 && norm(val) !== typed) continue;
          if (f === 'code') label = storeTitle(d) || docName(d);
        }
        if (!val || seen[norm(val)]) continue;
        seen[norm(val)] = true;
        opts.push([val, label, d[3] || '']);
      }
      /* lots newest-issued first (lot numbers are not zero-padded, so no string sort); names/codes A-Z */
      opts.sort(function (a, b) { return f === 'lot' ? (a[2] < b[2] ? 1 : a[2] > b[2] ? -1 : 0) : (a[0] < b[0] ? -1 : 1); });
      list.innerHTML = opts.slice(0, MAX_OPTIONS).map(function (o) { return '<option value="' + escapeHtml(o[0]) + '"' + (o[1] ? ' label="' + escapeHtml(o[1]) + '"' : '') + '></option>'; }).join('');
    });
  }

  function readCrit(form) {
    var crit = {};
    ['product', 'code', 'lot'].forEach(function (f) {
      var el = form.querySelector('[data-coa-field=' + f + ']');
      crit[f] = norm(el ? el.value : '').trim();
    });
    /* ?sku= / a pasted variant SKU: drop the pack suffix (31061-1 -> 31061). */
    crit.code = crit.code.replace(/^(p?\d{5}[a-z]?)-.*$/i, '$1');
    return crit;
  }
  function critLabel(form, crit) {
    return ['product', 'code', 'lot'].map(function (f) {
      var el = form.querySelector('[data-coa-field=' + f + ']');
      return crit[f] ? (el ? el.value.trim() : crit[f]) : '';
    }).filter(Boolean).join(' · ');
  }

  function search(box, form, q, strings) {
    var index = loadIndex(box, form.getAttribute('data-search-index'));
    if (!index) {
      /* No index on this page (lot page form): hand off to the CoA page. */
      var page = form.getAttribute('data-coa-page') || '/pages/certificates-of-analysis';
      window.location.href = page + '?q=' + encodeURIComponent(q);
      return;
    }
    var out = box.querySelector('[data-coa-results]');
    if (out) out.innerHTML = '<p class="coa__count">' + strings.searching + '</p>';
    index.then(function (docs) {
      var matches, label;
      if (typeof q === 'string') {
        /* Legacy free-text query (?q=, lot-page handoff): every word in any field. */
        var words = tokens(q), nq = norm(q).trim();
        label = q;
        matches = sortMatches(docs.filter(function (d) {
          var hay = norm(d[0]) + ' ' + norm(d[1]) + ' ' + productHay(d);
          return words.every(function (w) { return hay.indexOf(w) > -1; });
        }), function (a, b) { return rank(a, nq, words) - rank(b, nq, words); });
      } else {
        label = critLabel(form, q);
        matches = sortMatches(docs.filter(function (d) { return matchesCrit(d, q); }), function (a, b) { return rankCrit(a, q) - rankCrit(b, q); });
      }
      render(box, label, matches, strings);
    });
  }

  function init(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('form[data-coa-lookup]'), function (form) {
      if (form.__coa) return;
      form.__coa = true;
      var box = form.closest('[data-coa-box]') || form.parentNode;
      var strings = {
        searching: form.getAttribute('data-str-searching') || 'Searching…',
        results: form.getAttribute('data-str-results') || '{{ count }} certificates match “{{ query }}”:',
        more: form.getAttribute('data-str-more') || 'Showing the first {{ shown }}.',
        none: form.getAttribute('data-str-none') || 'No certificate found for “{{ query }}”.',
        lot: form.getAttribute('data-str-lot') || 'Lot',
        product: form.getAttribute('data-str-product') || 'Product',
        issued: form.getAttribute('data-str-issued') || 'Issued',
        download: form.getAttribute('data-str-download') || 'Download',
        empty: form.getAttribute('data-str-empty') || 'Choose or type a product, product code or lot number.'
      };
      var fields = form.querySelectorAll('[data-coa-field]');
      var params = new URLSearchParams(window.location.search);
      var out = box.querySelector('[data-coa-results]');
      if (!fields.length) {
        /* Single-box form (lot page): free-text handoff / search. */
        var input = form.querySelector('input[type=search]');
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var q = (input.value || '').trim();
          if (q) search(box, form, q, strings);
        });
        var param = params.get('q') || params.get('lot');
        if (param && box.querySelector('[data-coa-index]')) { input.value = param; search(box, form, param.trim(), strings); }
        return;
      }
      /* Multi-field form: cascading datalists + ANDed criteria. */
      var index = loadIndex(box, form.getAttribute('data-search-index'));
      /* Once loaded, refill synchronously inside the input event: Chrome shows the <datalist> as it stood when
         the popup opened, so an async (promise) refill left a stale suggestion ("Rabbit Brain ... (RBAP)"
         matched "ba", still listed at "bab"). */
      var loaded = null;
      if (index) index.then(function (docs) { loaded = docs; });
      var refill = function () {
        if (loaded) fillOptions(form, loaded);
        else if (index) index.then(function (docs) { fillOptions(form, docs); });
      };
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var crit = readCrit(form);
        if (!crit.product && !crit.code && !crit.lot) { if (out) out.innerHTML = '<p class="coa__none">' + escapeHtml(strings.empty) + '</p>'; return; }
        search(box, form, crit, strings);
      });
      form.addEventListener('input', refill);
      form.addEventListener('reset', function () { setTimeout(function () { refill(); if (out) out.innerHTML = ''; }, 0); });
      var prefill = { lot: params.get('lot'), code: params.get('code') || params.get('sku'), product: params.get('product') };
      var any = false;
      Array.prototype.forEach.call(fields, function (el) {
        var v = prefill[el.getAttribute('data-coa-field')];
        if (v) { el.value = v; any = true; }
      });
      refill();
      if (params.get('q')) search(box, form, params.get('q').trim(), strings);
      else if (any) search(box, form, readCrit(form), strings);
    });
  }

  window.theme = window.theme || {};
  window.theme.coaLookup = { baseCode: baseCode, indexTitles: indexTitles, storeTitle: storeTitle, productMatches: productMatches };
  if (window.theme.register) window.theme.register(init); else init(document);
})();
